import { Table } from "@/features/Table";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type E3TimeSerie, columns } from "./columns";
import { type FilterE3TimeSeriesSchema, FilterE3TimeSeries } from "./filter";

const client = Clients.E3;
const table_name = Tables.E3_TIME_SERIES;

export const E3TimeSeriesTable = () => {
  return (
    <Table<E3TimeSerie, FilterE3TimeSeriesSchema>
      label="Valorisation"
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<FilterE3TimeSeries />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
